export type DialogPresentation = "page" | "modal-card";

export const DEFAULT_DIALOG_PRESENTATION: DialogPresentation = "page";

interface ResolveDialogPresentationArgs {
  presentation?: DialogPresentation;
}

export function resolveDialogPresentation({
  presentation,
}: ResolveDialogPresentationArgs): DialogPresentation {
  if (presentation) {
    return presentation;
  }

  return DEFAULT_DIALOG_PRESENTATION;
}
